import { Component, inject, OnInit } from '@angular/core';
import { CustomBreadcrumbService } from 'src/app/services/breadcrumb.service';
import { PreviousRouteService } from './services/previous-route-service.service';
import { BreadcrumbService } from 'xng-breadcrumb';
import { NavigationHistoryService } from './services/navigation-history/navigation-history.service';
import { RouterOutlet } from '@angular/router';
import { ToastComponent } from '@tekus/design-system/components/toast';
import { PrimeNG } from 'primeng/config';

declare global {
  interface Window {
    updateMediaList: () => void;
    openUploader: () => void;
  }
}

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
  providers: [CustomBreadcrumbService, BreadcrumbService],
  imports: [RouterOutlet, ToastComponent]
})
export class AppComponent implements OnInit {
  private readonly primeNGConfig: PrimeNG = inject(PrimeNG);

  constructor(
    private previousRouteService: PreviousRouteService,
    private readonly customBreadcrumbService: CustomBreadcrumbService,
    private readonly navigationHistoryService: NavigationHistoryService
  ) {
    this.primeNGConfig.overlayAppendTo.set('body');
  }

  ngOnInit(): void {
    this.previousRouteService.getPreviousUrl();
    this.customBreadcrumbService.changeLabel();
  }
}
